<script setup lang="ts">
const props = defineProps({
  bordered: {
    type: Boolean,
    default: true,
  },
  variant: {
    type: String as PropType<"default" | "secondary">,
    default: "default",
  },
  radius: {
    type: String,
    default: "8px",
  },
  shadow: {
    type: Boolean,
    default: false,
  },
});

const variantClass = computed(() => {
  switch (props.variant) {
    case "secondary":
      return "card__container__grey";
    case "default":
    default:
      return "";
  }
});

const cardClass = computed(() => {
  return {
    card__container__bordered: props.bordered,
    card__container__shadow: props.shadow,
    [variantClass.value]: variantClass.value,
  };
});

const cardStyle = computed(() => ({
  borderRadius: props.radius,
}));
</script>

<template>
  <div class="card__container" :class="cardClass" :style="cardStyle">
    <slot name="body" />
  </div>
</template>

<style lang="scss" scoped>
.card__container {
  @apply flex flex-col px-8 py-6 w-full gap-4;
}

.card__container__bordered {
  border: 1px solid var(--grey-lightest);
}

.card__container__shadow {
  box-shadow: var(--shadow-soft);

  &:hover {
    box-shadow: var(--shadow-medium);
  }
}

.card__container__grey {
  background-color: var(--grey-light);
}
</style>
